import { CONTENT_PACK_SCHEMA_VERSION, parseManifestV2, sortManifestPacks } from './contentPackSchema';
import { stableStringify } from './hash';
import type { ContentManifestPack, ContentManifestV2, ContentPack } from './types';

export function updateManifest(
  current: unknown | null,
  releaseId: number,
  generatedAt: string,
  publishedPack: ContentManifestPack,
  editorialPacks: ContentPack[],
): ContentManifestV2 {
  const previous = current === null ? [] : parseManifestV2(current).packs;
  const allowed = new Set(editorialPacks.filter((pack) => pack.status === 'active').map((pack) => pack.id));
  const packs = previous.filter((pack) => pack.id !== publishedPack.id && allowed.has(pack.id));
  if (allowed.has(publishedPack.id)) packs.push(publishedPack);
  return { schemaVersion: CONTENT_PACK_SCHEMA_VERSION, releaseId, generatedAt, packs: sortManifestPacks(packs) };
}

export function serializeManifest(manifest: ContentManifestV2): Uint8Array {
  return new TextEncoder().encode(`${stableStringify(manifest)}\n`);
}
